module.exports = __webpack_public_path__ + "img/low-vision.ce82e847.svg";